import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'timeIndicator',
    standalone: false,
    pure: true
})
export class TimeIndicatorPipe implements PipeTransform {
  transform(sentAt: string | null | undefined): string {
    if (!sentAt) {
      return '';
    }
    const msgDate = DateTime.fromISO(sentAt);
    const now = DateTime.local();
    const time = msgDate.toFormat('h:mma').toLowerCase();
    if (msgDate.hasSame(now, 'day')) {
      return `Today ${time}`;
    }
    const yesterday = now.minus({ days: 1 });
    if (msgDate.hasSame(yesterday, 'day')) {
      return `Yesterday ${time}`;
    }
    if (msgDate.hasSame(now, 'year')) {
      return `${msgDate.toFormat('MMM d')  } ${time}`;
    }
    return `${msgDate.toFormat('MMM d, yyyy')  } ${time}`;
  }
}
